export const cohortBuilderTranslationCopyMessagesEn = {
  'projects.cohortBuilderPage.cohortDefinitionTranslation.copy': 'Copy {contentType}',
  'projects.cohortBuilderPage.cohortDefinitionTranslation.copiedToClipboard':
    'Copied {contentType} to clipboard',
};
